export default class SlideShow {
    infoChannelId: string = '';
}
